import React, { useState, useEffect } from 'react';
import {getUserIdFromStorage} from '../api/auth.sso';
import { apiRequest } from '../api/index';
import MyLeadsContent from '../components/MyLeads/MyLeadsContent';

const MyLeads = () => {
  const [userID, setUserID] = useState(null);
  const [packages, setPackages] = useState([]);
  const [packageTypes, setPackageTypes] = useState([]);
  const [flowTypes, setFlowTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Загрузка данных при монтировании компонента
  useEffect(() => {
    let isMounted = true;
    
    const loadData = async () => {
      try {
        setLoading(true);
        
        // Получаем ID пользователя
        const userIdFromStorage = getUserIdFromStorage();
        
        if (!isMounted) return;
        
        setUserID(userIdFromStorage);
        
        // Загружаем пакеты
        const loadedPackagesResponse = await apiRequest(`pakets?rekl_id=${userIdFromStorage}`, 'GET');
        const loadedPackages = loadedPackagesResponse.data?.pakets || [];
        
        if (!isMounted) return;
        
        setPackages(loadedPackages);
        
        // Загружаем типы пакетов
        const loadedPackageTypesResponse = await apiRequest('paks', 'GET');
        const loadedPackageTypes = loadedPackageTypesResponse.data || [];
        
        if (!isMounted) return;
        
        setPackageTypes(loadedPackageTypes);
        
        // Загружаем типы потоков
        const loadedFlowTypesResponse = await apiRequest('flow-guides', 'GET');
        const loadedFlowTypes = loadedFlowTypesResponse.data || [];
        
        if (isMounted) {
          setFlowTypes(loadedFlowTypes);
          setError(null);
        }
      } catch (err) {
        if (isMounted) {
          setError('Не удалось загрузить данные');
          console.error('Ошибка загрузки данных:', err);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };
    
    loadData();
    
    return () => {
      isMounted = false;
    };
  }, []);

  if (loading) {
    return (
      <main className="main-content">
        <div className="myleads-container">
          <div className="leads-table-container">
            <div className="loading">Загрузка...</div>
          </div>
        </div>
      </main>
    );
  }

  if (error) {
    return (
        <main className="main-content">
          <div className="myleads-container">
            <div className="error">{error}</div>
          </div>
        </main>
    );
  }

  return (
    <MyLeadsContent 
      userID={userID}
      packages={packages}
      packageTypes={packageTypes}
      flowTypes={flowTypes}
    />
  );
};

export default MyLeads;
